import type {
  QuizPlayerPostData,
  QuizPlayerScore,
} from '@mentimeter/quiz-types';

export const mergeMarkedAnswer = (
  payload: QuizPlayerPostData,
  players: QuizPlayerScore[],
) => {
  const byIdentifier: Record<string, string> = (
    payload.identifiers ?? []
  ).reduce((acc, identifier) => {
    return {
      ...acc,
      [identifier]: identifier,
    };
  }, {});

  return players.map((player) => {
    const isAffected = byIdentifier[player.player.identifier];
    if (!isAffected || !player.score.question) return player;
    return {
      ...player,
      score: {
        ...player.score,
        question: {
          ...player.score.question,
          markedCorrect: Boolean(payload.marked_correct),
          markedInappropriate: Boolean(payload.marked_inappropriate),
        },
      },
    };
  });
};
